import React, { useEffect, useContext } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { useLocation } from 'react-use'

import pageLinks from '../../constants/links'
import { GatsbyContext } from '../../context'

const MenuWraper = styled.nav`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100px;
  transition: 0.3s;
  margin-right: 30px;
  @media (max-width: 768px) {
    position: absolute;
    top: 60px;
    left: 0;
    height: auto;
    width: 100%;
    transform: translateY(${(props) => (props.status ? '0' : '-150%')});
  }
`

const MenuUl = styled.ul`
  display: flex;
  align-items: center;
  height: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    width: 100%;
    background-color: #fff;
  }
`
const MenuLi = styled.li`
  margin: 0 10px;

  height: 100%;
  position: relative;
  cursor: pointer;
  &:hover > ul {
    opacity: 1;
    pointer-events: all;
    height: auto;
    transform: translate(-20%, 0);
  }
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.theme.colors.font};
    height: 100%;
    padding: 0 10px;
    font-weight: 400;
    font-size: 1.5rem;
    @media (max-width: 768px) {
      height: auto;
    }
  }
  &:hover,
  .nav-active {
    color: #fff;
    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 3px;
      bottom: 0;
      left: 0;
      /* background-color: ${({ y }) => (y > 100 ? '#fff' : 'none')}; */
      background-color: #fff;
    }
  }
  ul {
    position: absolute;
    top: 97px;
    left: 0;
    /* transform: translateX(50%); */
    z-index: 999;
    opacity: 0;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    width: auto;
    box-sizing: border-box;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    /* overflow: hidden; */
    padding: 3px;
    transition: 0.3s all ease-in-out;
    background-color: #fff;
    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      top: -2px;
      left: 50%;
      transform: rotate(45deg) translateX(-50%);
      width: 10px;
      height: 10px;
      background-color: #fff;
    }
    li {
      a {
        white-space: nowrap;
        padding: 15px 35px;
        font-size: 1.4rem;
        transition: 0.3s all ease-in-out;
        font-weight: normal;
        background-color: ${(props) => props.theme.secondary};
        color: rgba(0, 0, 0, 0.8);
        &:hover {
          background-color: ${(props) => props.theme.colors.primary};
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          color: #fff;
          border-radius: 5px;
        }
        &::before {
          display: none;
        }
      }
      a.nav-active {
        color: #fff;
        background-color: ${(props) => props.theme.colors.primary};
      }
    }
  }
  @media (max-width: 768px) {
    min-height: 35px;
    width: 100%;
    line-height: 35px;
    &:hover,
    .nav-active {
      color: ${(props) => props.theme.colors.primary};
      &::before {
        display: none;
      }
    }
    a {
      padding: 5px;
      color: ${(props) => props.theme.colors.primary};
      font-size: 1.6rem;
      border-top: 1px solid #e4e7ed;
    }
    ul {
      opacity: 1;
      position: relative;
      border-radius: 0;
      border-top: 5px solid #00000005;
      top: 0;
      flex-wrap: wrap;
      padding: 0;
      box-shadow: none;
      flex-direction: row;
      padding-bottom: -1px;
      overflow: hidden;
      background-color: #00000010;
      &::before {
        display: none;
      }
      li {
        width: 50%;

        &:nth-child(odd) {
          border-right: 1px solid ${(props) => props.theme.colors.primary};
        }
        a {
          padding: 6px;
          border: 0;
          border-bottom: 1px dashed rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
`

const MenuItem = ({
  name,
  slug,
  sub,
  id,
  y,
  partiallyActive = true,
  activeMenu
}) => {
  const location = useLocation()
  return sub ? (
    <MenuLi y={y}>
      <Link
        to={'/' + slug + '/'}
        className={activeMenu === id ? 'nav-active' : ''}
        style={{ pointerEvents: 'none' }}
      >
        {name}
      </Link>
      <ul>
        {sub.map((x) => (
          <li key={x.id}>
            <Link
              to={'/' + slug + '/' + x.slug + '/'}
              // activeClassName="nav-active"
              // partiallyActive={true}
            >
              {x.name}
            </Link>
          </li>
        ))}
      </ul>
    </MenuLi>
  ) : name === '首页' ? (
    <MenuLi y={y}>
      <Link to={slug} className={activeMenu === 1 ? 'nav-active' : ''}>
        {name}
      </Link>
    </MenuLi>
  ) : (
    <MenuLi y={y}>
      <Link
        to={slug}
        // activeClassName="nav-active"
        // partiallyActive={partiallyActive}
        className={activeMenu === id ? 'nav-active' : ''}
      >
        {name}
      </Link>
    </MenuLi>
  )
}

const Menu = ({ status, y, toggle }) => {
  const location = useLocation()
  // console.log('🚀 ~ location', location)
  const { activeMenuID } = useContext(GatsbyContext)

  useEffect(() => {
    toggle(false)
  }, [location.pathname])
  return (
    <MenuWraper status={status}>
      <MenuUl>
        {/* <MenuItem name="首页" slug="/" y={y} partiallyActive={false} /> */}
        {pageLinks.map((menu) => (
          <MenuItem
            name={menu.name}
            slug={menu.slug}
            key={menu.id}
            id={menu.id}
            sub={menu.sub}
            activeMenu={activeMenuID}
            y={y}
          />
        ))}
      </MenuUl>
    </MenuWraper>
  )
}

export default Menu
